import { combineReducers } from 'redux';
import auth from './auth';
import admins from './admins';
import clients from './clients';
import clientCards from './clientCards';
import categories from './categories';
import types from './types';
import cards from './cards';
import places from './places';
import placeCards from './placeCards';
import reports from './reports';

export default combineReducers({
  auth,
  admins,
  clients,
  clientCards,
  cards,
  categories,
  types,
  places,
  placeCards,
  reports,
});



// WEBPACK FOOTER //
// ./src/modules/index.js